define('glu/log',['require'],function(require) {
    'use strict';

    return {
        console: window.console,

        debug: function() {
            return this.info.apply(this, arguments);
        },

        info: function() {
            var console = this.console;
            if (!console) {
                return;
            }

            return console.log.apply(console, arguments);
        },

        warn: function() {
            var console = this.console;
            if (!console) {
                return;
            }

            var method = console.warn ? 'warn' : 'log';
            return console[method].apply(console, arguments);
        },

        error: function() {
            var console = this.console;
            if (!console) {
                return;
            }

            var method = console.error ? 'error' : 'log';
            console[method].apply(console, arguments);

            if (console.trace) {
                console.trace.apply(console, arguments);
            }
        },

        level: function(level) {
            var silent = function() {};

            switch (level) {
                case 'INFO':
                    this.debug = silent;
                    break;
                case 'WARN':
                    this.debug = silent;
                    this.info = silent;
                    break;
                case 'ERROR':
                    this.debug = silent;
                    this.info = silent;
                    this.warn = silent;
                    break;
            }
        }
    };
});

